module.exports = __webpack_public_path__ + "fonts/TiemposTextWeb-RegularItalic.7b34b48f.woff2";